export type CancelFundingRequest = {
  type: 'CANCEL_REQUEST';
  id: string;
};

export const cancelFundingRequest = (id: string): CancelFundingRequest => ({
  type: 'CANCEL_REQUEST',
  id,
});
